import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { UserAuthContextProvider } from "./context/AuthContext";
import { UserDataContextProvider } from "./context/UserContext";


ReactDOM.render(
  <React.StrictMode>
    <UserAuthContextProvider>
      <UserDataContextProvider>
        <App />
      </UserDataContextProvider>
    </UserAuthContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
